export default __webpack_public_path__ + "static/media/CNo.91-4.9789f97f.jpg";